import * as params from '../util/params'

import * as util from '../util/util'

import * as ws_base from '../ws/ws_base'

const DOMINIO = "pedidos";



export async function novoPedido(id_usuario, titulo, descricao, data_expiracao){

	return await ws_base.post(DOMINIO, "novo", {"id_usuario": id_usuario, 
													"titulo": titulo,
														"descricao": descricao,
															"data_expiracao": data_expiracao});
}


export async function buscarPedidos(id_usuario, situacao, termos, index){

	return await ws_base.post(DOMINIO, "obter", {"id_usuario": id_usuario, 
													"situacao": situacao, 
														"termos": termos,
															"index": index});
}


export async function buscarPedidosDisponiveis(id_usuario){

	return await ws_base.post(DOMINIO, "obter_disponiveis", {"id_usuario": id_usuario});
}


export async function novoItemPedido(item){

	return await ws_base.post(DOMINIO, "novo_item", item);
}


export async function excluirPedido(id_pedido){
	
	return await ws_base.get(DOMINIO, "remover", {"id_pedido": id_pedido});
}


export async function buscarPedido(id_pedido){

	return await ws_base.get(DOMINIO, "obter", {"id": id_pedido});
}